export const en = (__LOCALE_EN__ ? ({
  filters: {
    popovers: {
      'external id': {
        label: 'Card ID',
      },
      fio: {
        label: 'Full name',
      },
      date: {
        label: 'Date created',
      },
      lists: {
        label: 'Lists',
      },
    },
    buttons: {
      'reset button': {
        label: 'Reset',
      },
    },
  },
  features: {
    'face duplicate': {
      'confirm popup': {
        title: 'A chance of a duplicate',
        description: 'The face you are adding probably already exists in the card',
        buttons: {
          'face sample button': 'Face details',
          'submit button': 'Add anyway',
          'reject button': 'Cancel',
        },
      },
    },
  },
  'sort dropdown options': {
    date_asc: 'By creation date (oldest first)',
    date_desc: 'By creation date (newest first)',
    fio_asc: 'By full name (A to Z)',
    fio_desc: 'By full name (Z to A)',
  },
  'person card': {
    created: 'Created',
    details: 'Details',
  },
  title: 'Card list',
  'cards found': 'Found: {{count}} card',
  'cards found_one': 'Found: {{count}} card',
  'cards found_few': 'Found: {{count}} cards',
  'cards found_many': 'Found: {{count}} cards',
  'cards found_other': 'Found: {{count}} cards',
  'quick search input label': 'Card ID or Full Name',
  'bulk actions': {
    'selected count': 'Selected cards: {{count}}',
    delete: 'Delete',
  },
  table: {
    columns: {
      card_id: 'Card ID',
      main_face_id: 'Photo',
      user_data: 'Name',
      create_time: 'Created at',
      lists: 'Lists',
    },
  },
}) : {}) as Record<string, unknown>;
export const ru = (__LOCALE_RU__ ? ({
  filters: {
    popovers: {
      'external id': {
        label: 'ID карточки',
      },
      fio: {
        label: 'ФИО',
      },
      date: {
        label: 'Дата создания',
      },
      lists: {
        label: 'Списки',
      },
    },
    buttons: {
      'reset button': {
        label: 'Очистить',
      },
    },
  },
  'sort dropdown options': {
    date_asc: 'По дате создания (сначала старые)',
    date_desc: 'По дате создания (сначала новые)',
    fio_asc: 'По ФИО (от А до Я)',
    fio_desc: 'По ФИО (от Я до А)',
  },
  'person card': {
    created: 'Создана',
    details: 'Детали',
  },
  title: 'Картотека',
  'quick search input label': 'ID Карточки или ФИО',
  'cards found': 'Найдено: {{count}} карточка',
  'cards found_one': 'Найдено: {{count}} карточка',
  'cards found_few': 'Найдено: {{count}} карточки',
  'cards found_many': 'Найдено: {{count}} карточек',
  'cards found_other': 'Найдено: {{count}} карточек',
  features: {
    'face duplicate': {
      'confirm popup': {
        title: 'Вероятность дубликата',
        description: 'Лицо, которое вы добавляете, вероятно уже есть в карточке',
        buttons: {
          'face sample button': 'Детали лица',
          'submit button': 'Всё равно добавить',
          'reject button': 'Отмена',
        },
      },
    },
  },
  'bulk actions': {
    'selected count': 'Выбрано карточек: {{count}}',
    delete: 'Удалить',
  },
  table: {
    columns: {
      card_id: 'ID карточки',
      main_face_id: 'Фото',
      user_data: 'ФИО',
      create_time: 'Создана',
      lists: 'Списки',
    },
  },
}) : {}) as Record<string, unknown>;
